export default __webpack_public_path__ + "static/i-info-web-f5c128f14de9a03897ce1ce673a4a45f.svg";